import initChoicesInstance from './initChoicesInstance';
import filterRowsByInstrument from './tables/filterRowsByInstrument';
import showTableById from './tables/showTableById';
import animateTable from './tables/animateTable';

const initQuotes = () => {
  const quotesChoice = document.querySelector('[data-quotes-choice]');
  const quotesChoiceInstance = initChoicesInstance(quotesChoice);

  const instrumentChoice = document.querySelector('[data-instrument-choice]');
  const instrumentChoiceInstance = initChoicesInstance(instrumentChoice, {
    position: 'bottom',
  });

  quotesChoice.addEventListener('choice', (e) => {
    const { value } = e.detail;

    showTableById(value);

    const tables = [...document.querySelectorAll('[data-table]')];
    tables.forEach(animateTable);
  });

  instrumentChoice.addEventListener('choice', (e) => {
    const { id, value } = e.detail;

    const table = document.querySelector('[data-table]');
    const tbody = table.querySelector('tbody');
    const rows = [...tbody.rows];

    // Returns all rows, if the 'All' option was selected
    const filteredRows = id === 1 ? rows : filterRowsByInstrument(table, value);
    rows.forEach((row) => row.classList.add('hidden'));
    filteredRows.forEach((row) => row.classList.remove('hidden'));

    animateTable(table);
  });
};

export default initQuotes;
